export interface CityData {
  slug: string;
  name: string;
  region: string;
  intro: string;
  local: string;
}

export const cities: CityData[] = [
  {
    slug: "berlin",
    name: "Berlin",
    region: "Berlin",
    intro:
      "Berlin hat eine der dichtesten E-Commerce-Szenen Deutschlands, von Fashion-Labels bis zu Food-Brands. Viele dieser Shops wachsen schnell und merken irgendwann, dass das erste Theme nicht mehr mitzieht.",
    local:
      "Ich arbeite remote und bin für Calls und Abstimmungen gut erreichbar. Für Berliner Unternehmen heißt das: Sie bekommen einen Shopify Entwickler, der auf Ihre Zeitzone und Ihren Rhythmus eingestellt ist, ohne Umwege über Zwischenebenen.",
  },
  {
    slug: "muenchen",
    name: "München",
    region: "Bayern",
    intro:
      "In München sitzen viele Hersteller und Marken mit hohen Ansprüchen an Qualität und Darstellung. Gerade dort wird der eigene Shop oft zum zweiten Standbein neben dem klassischen Vertrieb.",
    local:
      "Die Zusammenarbeit läuft remote, mit klaren Absprachen und festen Ansprechpartnern. Auf Wunsch stimmen wir uns per Video-Call ab, ein Vor-Ort-Termin ist für ein Shopify-Projekt in der Regel nicht nötig.",
  },
  {
    slug: "hamburg",
    name: "Hamburg",
    region: "Hamburg",
    intro:
      "Hamburg ist Handelsstadt, und viele traditionsreiche Händler stellen gerade ihren Online-Vertrieb auf Shopify um. Dabei geht es meist um saubere Prozesse und einen Shop, der ohne ständige Pflege läuft.",
    local:
      "Ich betreue Hamburger Kunden komplett remote: Aufgabe schildern, Einschätzung bekommen, Umsetzung in der Theme-Kopie, Freigabe, fertig. Ohne aufwendige Termine, dafür mit verbindlichen Zusagen.",
  },
  {
    slug: "koeln",
    name: "Köln",
    region: "Nordrhein-Westfalen",
    intro:
      "Der Kölner Raum hat viele mittelständische Händler, die online wachsen wollen, aber kein eigenes Entwicklerteam haben. Genau dafür ist ein Shopify Freelancer gedacht: direkt, ohne Zwischenstationen.",
    local:
      "Für Kunden aus Köln und dem Rheinland arbeite ich remote und bin während der Projektlaufzeit direkt erreichbar. Sie sprechen immer mit der Person, die auch umsetzt.",
  },
  {
    slug: "frankfurt-am-main",
    name: "Frankfurt am Main",
    region: "Hessen",
    intro:
      "Frankfurt steht für Handel, Finanzen und B2B. Viele Unternehmen dort brauchen einen Shop, der auch B2B-Preislisten, Staffelpreise oder Händlerkonditionen abbildet, genau die Stärke von Shopify B2B.",
    local:
      "Ich arbeite remote für Kunden in Frankfurt und dem Rhein-Main-Gebiet. Abstimmungen laufen per E-Mail oder Call, Ergebnisse sehen Sie immer zuerst in einer Testumgebung.",
  },
  {
    slug: "duesseldorf",
    name: "Düsseldorf",
    region: "Nordrhein-Westfalen",
    intro:
      "Düsseldorf ist stark in Mode, Kosmetik und Lifestyle. Diese Marken leben von ihrer Optik, und genau dort entscheidet die Umsetzung des Themes über die Conversion.",
    local:
      "Die Zusammenarbeit mit Düsseldorfer Marken läuft remote, vom ersten Konzept bis zur Freigabe. Änderungen sehen Sie immer zuerst in einer Kopie Ihres Shops, nie ungeprüft im Live-Betrieb.",
  },
  {
    slug: "stuttgart",
    name: "Stuttgart",
    region: "Baden-Württemberg",
    intro:
      "Im Raum Stuttgart sitzen viele Hersteller und Zulieferer, die den Direktvertrieb über Shopify aufbauen. Dazu gehören oft technische Produkte, die sauber erklärt und konfigurierbar sein müssen.",
    local:
      "Ich betreue Stuttgarter Unternehmen remote und arbeite mich auch in technische Produkte ein. Ziel ist ein Shop, den Ihre Kunden verstehen und den Ihr Team selbst pflegen kann.",
  },
  {
    slug: "wien",
    name: "Wien",
    region: "Österreich",
    intro:
      "Auch in Wien wächst der Handel über Shopify, von Manufakturen bis zu jungen Marken. Österreichische Shops brauchen dabei eigene Details wie ATU-Nummer, Widerruf und lokale Zahlarten sauber umgesetzt.",
    local:
      "Ich arbeite für Kunden in ganz Österreich, remote und in der gleichen Zeitzone. Mehrere meiner laufenden Projekte sind österreichische Shops.",
  },
];
